import get from 'lodash/get';

const FORBIDDEN_CODE = 403;

export default function isForbidden(e: unknown) {
  return get(e, 'response.status') === FORBIDDEN_CODE;
}
